export default "__VITE_ASSET__MkhmdY7Q__"